// src/layouts/MainLayout.jsx
import { Outlet } from "react-router-dom";
import BlogNavbar from "../PublicUser/components/common/Navbar";
import Footer from "../PublicUser/components/common/Footer";

const BlogLayout = () => {
  return (
    <div className="blog-layout">
      <BlogNavbar />

      <div className="blog-content">
        <Outlet />
      </div>

      <Footer />
    </div>
  );
};

export default BlogLayout;